import { faChevronRight, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
    sendingLink: boolean
    handleSendMagicLink: () => void
}

export default function CandidateEmailLinkButton({
    sendingLink,
    handleSendMagicLink,
}: Props): React.JSX.Element {
    return (
        <button
            type="button"
            disabled={sendingLink}
            onClick={handleSendMagicLink}
            className={`w-full rounded-2xl border border-primary/40 bg-primary text-primary-foreground px-5 py-4 text-left shadow-lg shadow-primary/30 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-2 flex items-center gap-4 ${
                sendingLink
                    ? 'cursor-not-allowed opacity-60'
                    : 'hover:bg-primary/90'
            }`}
        >
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/20 text-primary-foreground">
                <FontAwesomeIcon icon={faEnvelope} className="text-lg" />
            </span>
            <div className="flex-1 text-left">
                <p className="font-semibold leading-tight">Email me a link</p>
                <p className="text-sm leading-snug text-primary-foreground/80">
                    No password required.
                </p>
            </div>
            <FontAwesomeIcon icon={faChevronRight} className="text-lg" />
        </button>
    )
}
